import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import ShopClusterViewer from './subPages/shopCluster/ShopClusterViewer';
import ClusterViewer from './subPages/cluster/ClusterViewer';
import ProductClusterViewer from './subPages/productCluster/ProductClusterViewer';

const ClusterManagementTabs = ({ setTabIndex, index }: any) => {
    const translate = useTranslation();

    return (
        <Tabs size="sm" isLazy onChange={(index) => setTabIndex(index)} index={index}>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('clusterManagement.tab.shopCluster')}</Tab>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('clusterManagement.tab.cluster')}</Tab>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('clusterManagement.tab.productsCluster')}</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <ShopClusterViewer toolId={1} />
                </TabPanel>
                <TabPanel>
                    <ClusterViewer toolId={1} />
                </TabPanel>
                <TabPanel>
                    <ProductClusterViewer toolId={1} />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
};

export default ClusterManagementTabs;
